module.exports = __webpack_public_path__ + "img/aains-logo.b3a2f926.svg";